import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { Translate } from 'core/translate';
import { withModelInfo } from '../../common/ModelInfoContext';
import {
  CONFIG,
  remove
} from '../../resources/localStorage/localStorage.service';
import ErrorBoundary from '../../common/ErrorBoundary';
import dismissLoadingScreen from '../../common/dismissLoadingScreen';
import BrandLogo from '../../main/globalNav/BrandLogo';

const ErrorNav = ({ modelInfo }) => (
  <div className="global-nav">
    <div className="global-nav__bar">
      <BrandLogo modelInfo={modelInfo} />
    </div>
  </div>
);

function getContactUsURL({ country, language, brand, isMobile }) {
  if (country === 'US') {
    switch (brand) {
      case 'gmc':
        return 'http://www.gmc.com/contact-us/chat.html';
      case 'buick':
        return 'https://www.buick.com/help/contact-us/form.html';
      case 'chevrolet':
        return 'http://www.chevrolet.com/contact/call-us.html';
      case 'cadillac':
        return 'https://www.cadillac.com/help/contact-us/form.html';
      default:
        return 'https://www.gmfleet.com/contact.html';
    }
  }

  // Canada Desktop
  if (!isMobile) {
    if (_.includes(brand, 'fleet')) {
      switch (language) {
        case 'en':
          return 'http://www.gmfleet.ca/contact.html ';
        case 'fr':
          return 'http://fr.gmfleet.ca/contact.html';
      }
    }
    switch (language) {
      case 'en':
        return 'http://www.gm.ca/gm/english/corporate/about/contactus/overview';
      case 'fr':
        return 'http://www.gm.ca/gm/french/corporate/about/contactus/overview';
    }
  }

  const prefix = 'http://m.' + (language === 'fr' ? 'fr.' : '');
  switch (brand) {
    case 'gmc':
      return prefix + 'gmccanada.ca/chat.html';
    case 'buick':
      return prefix + 'buick.ca/talk-with-a-rep.html';
    case 'chevrolet':
      return prefix + 'chevrolet.ca/talk-with-a-rep.html';
    case 'cadillac':
      return prefix + 'cadillaccanada.ca/chat-with-an-agent.html';
    default:
      return prefix + 'gmfleet.ca/contact.html';
  }
}

const ErrorContent = ({ modelInfo, data = {}, isMobile }) => {
  const contactUsUrl = getContactUsURL({ ...modelInfo, isMobile });

  return (
    <div id="error-view">
      <div className="text-center">
        <div className="error-header" />
        <h3 className="error-upper-bold error-message">
          <Translate value="error.view.title" />
        </h3>
        <div className="error-line">
          <Translate value="error.view.error.message" />
        </div>
        <div>
          <div className="error-line">
            <a className="contact-us-link stat-text-link" href={contactUsUrl}>
              <Translate value="error.view.contact" />
            </a>{' '}
            <Translate value="error.view.contact.message" />
          </div>
          <div className="error-line error-upper-bold">
            <Translate value="error.view.apology.message" />
          </div>
        </div>
        <ErrorBoundary>
          <div className="error-contents">
            -- SESSION: --
            {data.selection}
            -- HEADER: --
            {data.header}
            -- DETAIL: --
            {JSON.stringify(data.detail)}
          </div>
        </ErrorBoundary>
      </div>
    </div>
  );
};

class Error extends React.Component {
  constructor(props) {
    super(props);
    const modelInfo = props.modelInfo;
    const error = props.error || {};
    const data = {
      errorData: error,
      header: error.message,
      detail: error.stack,
      lang: modelInfo.language,
      country: modelInfo.country,
      brand: modelInfo.brand,
      carline: modelInfo.carline,
      modelyear: modelInfo.year,
      bodystyle: modelInfo.bodyStyle
    };
    this.state = {
      data
    };
  }

  componentDidMount() {
    const { modelInfo } = this.props;
    const data = this.state.data;
    const {
      legacyServicesPath,
      country,
      language,
      brand,
      carline,
      year,
      bodyStyle
    } = modelInfo;

    dismissLoadingScreen();

    // clear localStorage config for current vehicle
    remove(modelInfo, CONFIG);

    // send to aggregation service
    fetch(`${legacyServicesPath}/diag`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({
        session: JSON.stringify({
          country,
          language,
          brand,
          carline,
          year,
          bodyStyle
        }),
        header: data.header,
        details: data.detail,
        agent: navigator.userAgent
      })
    });
  }

  render() {
    const { modelInfo, isMobile } = this.props;
    const data = this.state.data;

    return (
      <React.Fragment>
        <ErrorNav modelInfo={modelInfo} />
        <ErrorContent modelInfo={modelInfo} data={data} isMobile={isMobile} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ isMobile }) => ({ isMobile });

export default withRouter(withModelInfo(connect(mapStateToProps)(Error)));
